import { type ShipperAttachment } from '../domain/Document'
import { createShipperHttpClient } from '../infra/createShipperHttpClient'
import { ShipperRepository } from '../infra/ShipperRepository'

export type ListShipperAttachmentsFactoryDependencies = {
  shipperRepository: ShipperRepository
}

export function listShipperAttachmentsFactory({
  shipperRepository,
}: ListShipperAttachmentsFactoryDependencies) {
  return async function (
    uuid: string,
    config?: { signal?: AbortSignal }
  ): Promise<ShipperAttachment[]> {
    return shipperRepository.listShipperAttachments(uuid, config)
  }
}

export function listShipperAttachments(
  uuid: string,
  config?: { signal?: AbortSignal }
): Promise<ShipperAttachment[]> {
  const httpClient = createShipperHttpClient()
  const shipperRepository = new ShipperRepository({ httpClient })
  const listFn = listShipperAttachmentsFactory({ shipperRepository })
  return listFn(uuid, config)
}
